(function() {
  angular.module('registration')
    .controller('createAccountController',['$state', '$timeout', '$rootScope', '$translate', function($state, $timeout, $rootScope, $translate) {
    var vm = this;
    vm.registerNonDSO = registerNonDSO;
    vm.activeTab = $state.current.name;
    vm.applicationName = $rootScope.applicationName;
    
    function registerNonDSO() {
      $state.go('registration.nonDso');
    }
  }]);
})();
